import React from "react";

export default function CSS_Templates() {
  return (
    <div className="tutorial-page">
      <h1>CSS Templates</h1>
      <p>This is the CSS Templates tutorial page.</p>
    </div>
  );
}
